import React from 'react';
import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';

const LightBackground = ({ isFilterActive, toggleOption }) => {
	const handleLightBackground = () => {
		if (!isFilterActive) {
			document.querySelectorAll('.filter').forEach((element) => {
				element.style.filter = '';
			});

			document.querySelectorAll('section, .filter, .filterbg').forEach((element) => {
				element.style.background = 'white';
			});
			document
				.querySelectorAll('.MuiTypography-root, .MuiTypography-root *, .MuiIconButton-root')
				.forEach((element) => {
					element.style.color = 'black';
				});
		}

		toggleOption();
	};
	return (
		<ListItem
			className='accessiblility-links'
			tabIndex={1}
			sx={{
				padding: '5px 18px',
				cursor: 'pointer',
				background: isFilterActive
					? (theme) => theme.palette.accessibilityBtn.main
					: (theme) => theme.palette.common.white,
				color: isFilterActive ? (theme) => theme.palette.common.white : 'inherit'
			}}
			onClick={handleLightBackground}
			onKeyDown={(event) => {
				if (event.key === 'Enter') {
					handleLightBackground();
				}
			}}
		>
			<EmojiObjectsOutlinedIcon
				sx={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '5px' }}
			/>
			<ListItemText
				primary='Light Background'
				primaryTypographyProps={{
					sx: {
						fontSize: '14px'
					}
				}}
			/>
		</ListItem>
	);
};

LightBackground.propTypes = {
	isFilterActive: PropTypes.bool,
	toggleOption: PropTypes.func
};

export default LightBackground;
